import React from 'react';
import { Card, Row, Col, Statistic, Typography } from 'antd';
import {
  DashboardOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  BellOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Title level={2}>
        <DashboardOutlined /> Home Dashboard
      </Title>
      <Paragraph>Welcome to your personal workspace. Quick access to your tasks, drafts, and alerts.</Paragraph>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card
            hoverable
            onClick={() => navigate('/home/tasks')}
            style={{ cursor: 'pointer' }}
          >
            <Statistic
              title="My Tasks"
              value={12}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card
            hoverable
            onClick={() => navigate('/home/drafts')}
            style={{ cursor: 'pointer' }}
          >
            <Statistic
              title="My Drafts"
              value={5}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card
            hoverable
            onClick={() => navigate('/home/alerts')}
            style={{ cursor: 'pointer' }}
          >
            <Statistic
              title="My Alerts"
              value={8}
              prefix={<BellOutlined />}
              valueStyle={{ color: '#145A54' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card
            hoverable
            onClick={() => navigate('/home/exceptions')}
            style={{ cursor: 'pointer' }}
          >
            <Statistic
              title="Exceptions"
              value={3}
              prefix={<WarningOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={16}>
          <Card title="Recent Activity" bordered={false}>
            <Paragraph>Your recent actions and updates will appear here.</Paragraph>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card title="Quick Links" bordered={false}>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: 8 }}>
                <a onClick={() => navigate('/dashboard')}>My Workboard</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a onClick={() => navigate('/home/company-overview')}>Company Overview</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a onClick={() => navigate('/growth/orders')}>Customer Orders</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a onClick={() => navigate('/mfg/work-orders')}>Work Orders</a>
              </li>
              <li style={{ marginBottom: 8 }}>
                <a onClick={() => navigate('/qms/ncrs')}>NCRs</a>
              </li>
            </ul>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default HomePage;
